import axios from "../axios";

const getSecurity = async function (accessToken) {
    try {
        const response = await axios.get('/profile/getSecurity', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getSecurity;
